module.exports = __webpack_public_path__ + "img/piletivahetus_ostamuuvaheta.998983c7.png";